import { supabase } from '@/core/database/supabase';
import type { UserProfile } from '../../list/types/userList.types';
import type { UserEditFormData } from '../types/userEdit.types';

export const UserEditService = {
  async getUserById(id: string): Promise<UserProfile> {
    const { data, error } = await supabase
      .from('user_profiles')
      .select('*')
      .eq('id', id)
      .single();

    if (error) throw error;
    return data as UserProfile;
  },

  async updateUser(id: string, payload: Partial<UserEditFormData>): Promise<void> {
    const { error } = await supabase
      .from('user_profiles')
      .update(payload)
      .eq('id', id);

    if (error) throw error;
  }
};
